'use client';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

type IBanner = {
  width?: number;
  height?: number;
  size?: 'large' | 'medium' | 'small';
};

export default function BannerAds({}: IBanner): JSX.Element {
  const banner = useRef<HTMLDivElement>(null);

  const atOptions = {
    key: 'a19568c0bcf5a8e50a44301944dee5a5',
    format: 'iframe',
    height: 90,
    width: 728,
    params: {},
  };
  useEffect(() => {
    // setTimeout(() => {
    //   window
    //     .open(
    //       'https://www.effectiveratecpm.com/tryeqe1b?key=1afeebad079860aae9455a986566e4b0',
    //     )
    //     ?.focus();
    // }, 1000);
    if (banner.current && !banner.current.firstChild && window.innerWidth > 768) {
      const conf = document.createElement('script');
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `//www.highperformancedformats.com/${atOptions.key}/invoke.js`;
      conf.innerHTML = `atOptions = ${JSON.stringify(atOptions)}`;

      banner.current.append(conf);
      banner.current.append(script);
    }
    console.log(window.innerWidth);
  }, [banner]);

  return (
    <div className="max-md:hidden block">
      <div
        className="mx-2 my-5 max-md:hidden justify-center items-center text-white text-center"
        ref={banner}
      ></div>
      <Script
        type="text/javascript"
        className="max-md:hidden"
        src="//www.highperformanceformat.com/a19568c0bcf5a8e50a44301944dee5a5/invoke.js"
      />
    </div>
  );
}
